import { Asset, AssetsAPI, DisplayableAsset, Entry, RDEqipFsaForms } from '@cibo/core'
import { Loading } from '@cibo/profile'
import {
  ResourceDetailFeatureTaskEditorProps,
  downloadAxiosResponse,
  useTraitContent,
} from '@cibo/ui'
import InsertDriveFileOutlined from '@mui/icons-material/InsertDriveFileOutlined'
import { Button, Card, FormHelperText, Stack, Typography } from '@mui/material'
import { EntrySkeletonType } from 'contentful'
import { useTranslation } from 'react-i18next'
import { useUpdateProgramEngagementDetails } from '../../../../queries'

export const RDEqipFsaFormsTaskEditor = ({
  detailRequirements,
  resourceIds: [resourceId],
}: ResourceDetailFeatureTaskEditorProps<RDEqipFsaForms>) => {
  const { t } = useTranslation('@cibo/programs/RDEqipFsaFormsTaskEditor')
  const content = useTraitContent('eqipFsaForms')
  const updateEngagementDetail = useUpdateProgramEngagementDetails()

  const onClick = async (url: string, fileName: string) => {
    AssetsAPI.proxy({ url: `${window.location.protocol}${url}` }).then(response => {
      downloadAxiosResponse(fileName)(response)
      updateEngagementDetail.mutateAsync({
        engagementId: resourceId,
        details: [
          {
            traitId: 'eqipFsaForms',
            year: detailRequirements[0].year,
            result: {
              //TODO: only update the form that was clicked
              agiCertification: true,
              highlyErodibleOrWetlandConservation: true,
            },
          } as RDEqipFsaForms,
        ],
      })
    })
  }

  if (content.isPending) {
    return <Loading />
  }

  return (
    <Stack spacing={3}>
      <Stack>
        <Typography variant="h6">{t('fsaForms')}</Typography>
        <Typography variant="body2" color="text.secondary">
          {t('fsaFormsDescription')}
        </Typography>
      </Stack>

      {(
        content.data?.fields.displayableAssets as
          | Entry<EntrySkeletonType<DisplayableAsset>>[]
          | undefined
      )?.map(({ fields: { asset, title, description } }) => (
        <Card key={(asset as Asset | undefined)?.sys.id} variant="outlined">
          <Stack direction="row" alignItems="center" padding={2} spacing={3} flex={1}>
            <InsertDriveFileOutlined color="action" />
            <Stack flex={1}>
              <Typography variant="body1">{title}</Typography>
              <Typography variant="body2" color="text.secondary">
                {(asset as Asset | undefined)?.fields.title}
              </Typography>
              {!!description && (
                <Typography variant="body2" color="text.secondary">
                  {description}
                </Typography>
              )}
            </Stack>
            <Button
              color="secondary"
              onClick={() =>
                (asset as Asset | undefined)?.fields.file &&
                onClick(
                  (asset as Asset)?.fields.file?.url || '',
                  (asset as Asset)?.fields.file?.fileName || ''
                )
              }
            >
              {t('download')}
            </Button>
          </Stack>
        </Card>
      ))}

      <FormHelperText>{t('formHelperText')}</FormHelperText>
    </Stack>
  )
}
